/* revo-cart-events.js — Revo Clothing
 * Eventos de carrinho (pré-checkout) enviados direto ao webhook da Notificações Inteligentes.
 * Envia: carts/create, carts/update, carts/clear, carts/abandoned
 */
(function () {
  const WEBHOOK_URL = 'https://webhooks.notificacoesinteligentes.com/fd33981e-4da5-4933-bb62-88a00821d96e/shopify-revo';
  const WEBHOOK_SECRET = '';        // opcional (combine com a NI)
  const API_VERSION = '2025-01';
  const ABANDON_TIMEOUT_MIN = 30;   // minutos sem iniciar checkout => abandono
  const SEND_DEBUG_LOGS = false;
  const UTM = 'utm_source=whatsapp&utm_medium=cart_recovery&utm_campaign=revo_cart';
  const log = (...a) => SEND_DEBUG_LOGS && console.log('[REVO CART]', ...a);
  const nowISO = () => new Date().toISOString();

  async function fetchCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }
  function toMoney(cents) { return (cents || 0) / 100; }
  async function buildCartPermalink(cart) {
    try {
      const items = (cart.items || []).map(it => `${it.variant_id}:${it.quantity}`);
      if (!items.length) return null;
      const origin = window.__revoShop?.url || window.location.origin;
      return `${origin}/cart/${items.join(',')}?${UTM}`;
    } catch (e) { log('permalink error', e); return null; }
  }
  function cartToData(cart) {
    return {
      id: cart?.token || null,
      token: cart?.token || null,
      currency: window.__revoShop?.currency || null,
      total_price: cart?.total_price || 0,
      total_price_decimal: toMoney(cart?.total_price),
      item_count: cart?.item_count || 0,
      items: (cart?.items || []).map(it => ({
        product_id: it.product_id,
        variant_id: it.variant_id,
        title: it.title,
        sku: it.sku,
        quantity: it.quantity,
        price: it.price,
        price_decimal: toMoney(it.price),
        line_price: it.line_price,
        line_price_decimal: toMoney(it.line_price),
        image: it.image,
        url: it.url,
        vendor: it.vendor,
      })),
      customer: {
        id: window.__revoCustomer?.id || null,
        email: window.__revoCustomer?.email || null,
        phone: window.__revoCustomer?.phone || null,
        first_name: window.__revoCustomer?.first_name || null,
        accepts_marketing: window.__revoCustomer?.accepts_marketing || null
      }
    };
  }
  async function postEvent(topic, cart, extraHeaders = {}, extraData = {}) {
    const payload = {
      topic,
      created_at: nowISO(),
      shop_domain: window.__revoShop?.myshopify_domain || window.location.hostname,
      api_version: API_VERSION,
      data: { ...(cartToData(cart)), permalink: await buildCartPermalink(cart), ...extraData }
    };
    const headers = {
      'Content-Type': 'application/json',
      'X-Revo-Source': 'theme',
      'X-Revo-Topic': topic,
      ...(WEBHOOK_SECRET ? { 'X-Revo-Secret': WEBHOOK_SECRET } : {}),
      ...extraHeaders
    };
    log('POST', topic, payload);
    try { await fetch(WEBHOOK_URL, { method: 'POST', headers, body: JSON.stringify(payload) }); }
    catch (e) { log('Webhook error', e); }
  }

  let abandonTimer = null;
  let lastCart = null;
  function clearAbandonTimer() { if (abandonTimer) { clearTimeout(abandonTimer); abandonTimer = null; } }
  async function armAbandonTimer(cart) {
    clearAbandonTimer(); lastCart = cart;
    if (!cart || !cart.item_count) return;
    abandonTimer = setTimeout(async () => { await postEvent('carts/abandoned', lastCart); }, ABANDON_TIMEOUT_MIN * 60 * 1000);
  }
  document.addEventListener('click', (e) => {
    const el = e.target.closest('a,button,input[type=submit]'); if (!el) return;
    const txt = (el.innerText || el.value || '').toLowerCase();
    const href = (el.getAttribute && el.getAttribute('href')) || '';
    if (txt.includes('checkout') || href.includes('/checkout')) { clearAbandonTimer(); }
  }, true);

  const CART_HINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const OFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    const isCartCall = CART_HINTS.some(h => url.includes(h));
    const res = await OFetch.apply(this, arguments);
    if (isCartCall && res.ok) {
      setTimeout(async () => {
        try {
          const previousCount = lastCart?.item_count || 0;
          const cart = await fetchCart();
          const nowCount = cart?.item_count || 0;
          if (previousCount === 0 && nowCount > 0) { await postEvent('carts/create', cart); }
          else if (nowCount === 0) { await postEvent('carts/clear', cart); }
          else { await postEvent('carts/update', cart); }
          await armAbandonTimer(cart); lastCart = cart;
        } catch (e) { /* noop */ }
      }, 250);
    }
    return res;
  };
  document.addEventListener('submit', (e) => {
    try {
      const form = e.target; if (!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (action.includes('/cart/add')) {
        setTimeout(async () => {
          const previousCount = lastCart?.item_count || 0;
          const cart = await fetchCart();
          const nowCount = cart?.item_count || 0;
          if (previousCount === 0 && nowCount > 0) { await postEvent('carts/create', cart); }
          else { await postEvent('carts/update', cart); }
          await armAbandonTimer(cart); lastCart = cart;
        }, 500);
      }
    } catch {}
  }, true);
  (async function init() { try { const cart = await fetchCart(); lastCart = cart; await armAbandonTimer(cart); } catch {} })();
})();
